export default __webpack_public_path__ + "static/media/image-close.48489918.svg";